import { LINKS } from "../../config/links";

const OPTIONS = [
  {
    label: "Book A Strategy Session",
    sub: "30 min · Free · Live system mapping",
    href: LINKS.calendar,
    testid: "final-cta-book-call",
    tone: "primary",
    external: false,
  },
  {
    label: "Send Me the Content Kit",
    sub: "5 ChatGPT prompts · Instant access",
    href: LINKS.leadMagnet,
    testid: "final-cta-download-guide",
    tone: "secondary",
    external: true,
  },
  {
    label: "Build My Starter System",
    sub: "Get my automation installed",
    href: LINKS.starterSetup,
    testid: "final-cta-start-500",
    tone: "secondary",
    external: true,
  },
];

export default function FinalCTA() {
  return (
    <section
      id="book-call"
      data-testid="final-cta-section"
      className="relative py-28 sm:py-36 overflow-hidden border-t border-white/5"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1733]/80 via-[#15294e]/50 to-[#0a1733]/80" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[420px] w-[1200px] bg-amber-500/[0.08] blur-[140px] rounded-full" aria-hidden />
        <div className="absolute inset-0 noise-overlay" aria-hidden />
      </div>

      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="reveal flex items-center gap-3 justify-center mb-8">
          <span className="h-[1px] w-12 bg-amber-500/70" />
          <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
            Let's Fix Your Pipeline Today
          </span>
          <span className="h-[1px] w-12 bg-amber-500/70" />
        </div>

        <h2
          data-testid="final-cta-headline"
          className="reveal font-display font-light text-white text-balance text-4xl sm:text-5xl lg:text-[68px] leading-[1.02] tracking-[-0.02em] text-center"
          style={{ transitionDelay: "80ms" }}
        >
          Your business shouldn't feel like{" "}
          <span className="italic text-amber-400">survival mode.</span>
        </h2>

        <p
          className="reveal mt-6 max-w-2xl mx-auto text-slate-300 text-base sm:text-lg leading-relaxed text-center"
          style={{ transitionDelay: "160ms" }}
        >
          From stress to systems. From chasing to building. Pick the path
          that matches where you are right now — you don't have to figure
          this out alone.
        </p>

        <div className="reveal mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {OPTIONS.map((o, i) => (
            <a
              key={o.testid}
              href={o.href}
              data-testid={o.testid}
              target={o.external ? "_blank" : undefined}
              rel={o.external ? "noopener noreferrer" : undefined}
              className={`group relative flex flex-col items-start justify-between p-7 min-h-[180px] transition-all duration-300 hover:-translate-y-1 ${
                o.tone === "primary"
                  ? "bg-amber-600 hover:bg-amber-500 text-slate-950"
                  : "bg-white/[0.03] hover:bg-white/[0.06] border border-white/15 hover:border-amber-400/60 text-white"
              }`}
              style={{ transitionDelay: `${200 + i * 80}ms` }}
            >
              <div className={`font-sans-body uppercase text-[10px] tracking-[0.28em] ${o.tone === "primary" ? "text-slate-800" : "text-amber-400"}`}>
                Option 0{i + 1}
              </div>

              <div className="flex-1 flex items-end">
                <div>
                  <div className={`font-display text-2xl leading-tight ${o.tone === "primary" ? "text-slate-950" : "text-white"}`}>
                    {o.label}
                  </div>
                  <div className={`mt-2 text-xs ${o.tone === "primary" ? "text-slate-800/80" : "text-slate-400"}`}>
                    {o.sub}
                  </div>
                </div>
              </div>

              <div className={`mt-5 flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-bold ${o.tone === "primary" ? "text-slate-900" : "text-amber-400"}`}>
                <span>Go</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="transition-transform group-hover:translate-x-1">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </div>
            </a>
          ))}
        </div>

        <p className="reveal mt-10 text-center text-[12px] uppercase tracking-[0.24em] text-slate-500">
          Free · No pressure · Just clarity
        </p>
      </div>
    </section>
  );
}
